import _ from 'lodash';
import { Components, FormioUtils } from '@formio/angular';
const DateTimeComponent = Components.components.datetime;
export class UTCDateTime extends DateTimeComponent {
    getValue() {
        const supersValue = super.getValue();
        const asArray = _.castArray(supersValue);
        if (this._isUTCStartOfDayMode()) {
            _.forEach(asArray, (val, idx) => {
                const adjustedValue = FormioUtils.momentDate(val, null, null);
                if (adjustedValue.isValid()) {
                    // if start of day localTZ, assume safe to shift timezone w/o converting time
                    const shiftTimezone = adjustedValue.local().hours() === 0;
                    val = adjustedValue.utc(shiftTimezone).toISOString();
                    asArray[idx] = val;
                }
            });
        }
        // if provided an array, keep the original reference
        return _.isArray(supersValue) ? supersValue : _.first(asArray);
    }
    updateValue(value, flags, index) {
        const asArray = _.castArray(value);
        if (this._isUTCStartOfDayMode()) {
            _.forEach(asArray, (val, idx) => {
                const adjustedValue = FormioUtils.momentDate(val, null, null);
                if (adjustedValue.isValid()) {
                    // if start of day UTC, assume safe to shift timezone w/o converting time
                    const shiftTimezone = adjustedValue.utc().hours() === 0;
                    val = adjustedValue.local(shiftTimezone).toISOString();
                    asArray[idx] = val;
                }
            });
        }
        // if provided an array, keep the original reference
        return super.updateValue(_.isArray(value) ? value : _.first(asArray), flags, index);
    }
    _isUTCStartOfDayMode() {
        const { enableTime, displayInTimezone } = this.component;
        return !enableTime && displayInTimezone === 'utc';
    }
}
